/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiGiftRedemption } from './GiftRedemption';

export interface GiftItemRequest {

    id?: string;

    /**
     * Purchaser's name
     */
    purchaser_name?: string;

    /**
     * Email of the gift recipient
     */
    recipient_email?: string;

    /**
     * Name of the gift recipient
     */
    recipient_name?: string;

    /**
     * Message to include with the gift
     */
    gift_message?: string;

    /**
     * Date to deliver the gift at
     */
    deliver_at?: string;

    /**
     * Date the gift was delivered at
     */
    delivered_at?: string;

    /**
     * The date the gift was cancelled at
     */
    canceled_at?: string;

    /**
     * The date the gift was redeemed at
     */
    redeemed_at?: string;

    /**
     * The date of next renwal payment
     */
    renews_on?: string;

    /**
     * The payment source for renewals
     */
    payment_source?: string;

    /**
     * True if this is a recurring gift subscription
     */
    recurring?: boolean;

    /**
     * True if this is a sponsorship gift subscription
     */
    sponsorship?: boolean;

    /**
     * Number of sponsorships purchased
     */
    purchased_quantity?: number;

    /**
     * The sku of the membership product being gifted
     */
    product_sku?: string;

    /**
     * The id of the sponsorship product purchased
     */
    sponsorship_product_id?: number;

    /**
     * Whether the renewable gift item is expired. Meaning is undefined if gift is not recurring.
     */
    renewable_expired?: boolean;

    /**
     * Timestamp for when the renewable gift item expired. Meaning is undefined if gift is not recurring.
     */
    renewable_expired_at?: string;

    /**
     * The name of the theme to show the recipient
     */
    theme_name?: string;

    /**
     * The fixed duration of the gift subscription, in months
     */
    months?: number;

    /**
     * Email of the gift purchaser
     */
    purchaser_email?: string;

    /**
     * Date the gift was created at
     */
    created_at?: string;

    /**
     * The price of the membership product being gifted
     */
    dollar_price?: string;

    /**
     * Redemption code of gift item
     */
    code?: string;

    /**
     * Redemption url of gift item
     */
    redemption_url?: string;

    /**
     * The date the gift was reminded at
     */
    reminded_at?: string;

    gift_redemptions?: ApiGiftRedemption[];

    /**
     * The number of redemptions so far
     */
    redemptions_count?: number;

}

@Model('GiftItem')
export class ApiGiftItem extends BaseModel implements GiftItemRequest {

    
    
    id: string;

    /**
     * Purchaser's name
     */
    
    
    purchaser_name: string;

    /**
     * Email of the gift recipient
     */
    
    
    recipient_email: string;

    /**
     * Name of the gift recipient
     */
    
    
    recipient_name: string;

    /**
     * Message to include with the gift
     */
    
    
    gift_message: string;

    /**
     * Date to deliver the gift at
     */
    
    
    deliver_at: string;

    /**
     * Date the gift was delivered at
     */
    
    
    delivered_at: string;

    /**
     * The date the gift was cancelled at
     */
    
    
    canceled_at: string;

    /**
     * The date the gift was redeemed at
     */
    
    
    redeemed_at: string;

    /**
     * The date of next renwal payment
     */
    
    
    renews_on: string;

    /**
     * The payment source for renewals
     */
    
    
    payment_source: string;

    /**
     * True if this is a recurring gift subscription
     */
    
    
    recurring: boolean;

    /**
     * True if this is a sponsorship gift subscription
     */
    
    
    sponsorship: boolean;

    /**
     * Number of sponsorships purchased
     */
    
    
    purchased_quantity: number;

    /**
     * The sku of the membership product being gifted
     */
    
    
    product_sku: string;

    /**
     * The id of the sponsorship product purchased
     */
    
    
    sponsorship_product_id: number;

    /**
     * Whether the renewable gift item is expired. Meaning is undefined if gift is not recurring.
     */
    
    
    renewable_expired: boolean;

    /**
     * Timestamp for when the renewable gift item expired. Meaning is undefined if gift is not recurring.
     */
    
    
    renewable_expired_at: string;

    /**
     * The name of the theme to show the recipient
     */
    
    
    theme_name: string;

    /**
     * The fixed duration of the gift subscription, in months
     */
    
    
    months: number;

    /**
     * Email of the gift purchaser
     */
    
    
    purchaser_email: string;

    /**
     * Date the gift was created at
     */
    
    
    created_at: string;

    /**
     * The price of the membership product being gifted
     */
    
    
    dollar_price: string;

    /**
     * Redemption code of gift item
     */
    
    
    code: string;

    /**
     * Redemption url of gift item
     */
    
    
    redemption_url: string;

    /**
     * The date the gift was reminded at
     */
    
    
    reminded_at: string;

    @Type('ApiGiftRedemption')
    @Expand()
    gift_redemptions: ApiGiftRedemption[];

    /**
     * The number of redemptions so far
     */
    
    
    redemptions_count: number;

}
